import React from 'react'
import { Flex } from '@chakra-ui/core'

import LocaleText from 'components/LocaleText'
import { SearchInput } from 'components/TasksV2/Insights/Content/ContextsList/SearchInput'
import { NoFocusButton } from '../NoFocusButton'
import { getHeaderJustifyContent } from './utils'
import { GroupedSelectMode } from './types'

interface Props {
  searchText: string
  setSearchText: (v: string) => void
  onSelectAll?: () => void
  onClear: () => void
  mode: GroupedSelectMode
  isNoResults: boolean
  hasSelectedItems: boolean
  searchInputRef?: React.RefObject<HTMLInputElement>
}

const BUTTON_STYLES = {
  size: 'xs' as const,
  bg: 'white' as const,
  borderRadius: '5px' as const,
}

export const GroupedSelectHeader: React.FC<Props> = ({
  searchText,
  setSearchText,
  onSelectAll,
  onClear,
  mode,
  isNoResults,
  hasSelectedItems,
  searchInputRef,
}) => {
  const justifyContent = getHeaderJustifyContent({ mode, onSelectAll })

  return (
    <>
      <SearchInput
        ref={searchInputRef}
        w="100%"
        borderRadius="5px"
        border="1px solid #e0e0e0"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchText(e.target.value)}
        value={searchText}
      />
      {!isNoResults && (
        <Flex pt="2" justifyContent={justifyContent}>
          {mode === 'multiple' && onSelectAll && (
            <NoFocusButton onClick={onSelectAll} {...BUTTON_STYLES}>
              <LocaleText text="select_all_stores_button" />
            </NoFocusButton>
          )}
          <NoFocusButton onClick={onClear} {...BUTTON_STYLES} isDisabled={!hasSelectedItems}>
            <LocaleText text="clear_filter" />
          </NoFocusButton>
        </Flex>
      )}
    </>
  )
}
